'use client';

import React from 'react';
import type { LandscapePress } from '@/types';

import { formatDateNumeric } from '@/lib/utils/date-format';

interface LandscapePressProps {
  layout: LandscapePress;
}

interface pressItemsProps {
  publication: string;
  date: string;
  headline: string;
  url: string;
}

export const Landscape_Press: React.FC<LandscapePressProps> = ({ layout }) => {
  let pressItems: pressItemsProps[] = [];

  layout.press.forEach(item => {
    if (typeof item === 'number') return;
    pressItems.push({
      publication: item.publisher || '',
      
      // date: dd/mm/yyyy format for consistency
      date: formatDateNumeric(item.publishDate),
      headline: item.title || '',
      url: item.originalLink || '',
    });
  });

  return (
    <section className="w-full">
      <div className="p-[15px] rounded-md bg-white mb-[12px] flex flex-col justify-between relative pt-4">
        <div className="mb-2">
          <div className="uppercase text-gray-500 text-[10px]">[ PRESS ]</div>
        </div>

        <div className="w-full overflow-x-auto">
          <table className="w-full border-collapse text-[12px]">
            <thead className="border-b border-gray-200">
              <tr className="text-left">
                <th className="py-3 font-mono text-[10px] text-gray-500 sm:w-1/4">PUBLICATION</th>
                <th className="py-3 font-mono text-[10px] text-gray-500 sm:w-1/6 hidden sm:table-cell">DATE</th>
                <th className="py-3 font-mono text-[10px] text-gray-500">HEADLINE</th>
                <th className="py-3 w-[70px] sm:w-[100px]"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {pressItems.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                  <td className="py-3 font-semibold text-[10px]">
                    <a
                      href={item.url || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-zinc-700 text-[10px] font-mono"
                    >
                      {item.publication}
                    </a>
                  </td>
                  <td className="py-3 text-gray-500 text-[10px] hidden sm:table-cell">{item.date}</td>
                  <td className="py-3 text-[10px] truncate max-w-[150px] sm:max-w-none">
                    {item.headline}
                    <div className="text-gray-500 text-[9px] sm:hidden mt-1">{item.date}</div>
                  </td>
                  <td className="py-3 text-right">
                    <a
                      href={item.url || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-zinc-500 hover:text-zinc-700 text-[10px] font-mono"
                    >
                      READ →
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
